export default __webpack_public_path__ + "static/media/g2.35c2539b.webp";